export default function createListFormatter(locale) {
  return (list, options) => new Intl.ListFormat(locale, options).format(list);
}
